export const DOI_PREFIX = "10.55834";
export const domainSlugs = {
	["self-management"]: "Self-Management",
	["operations-and-policy"]: "Operations and Policy",
	["quality-and-risk"]: "Quality and Risk",
	["strategy-and-innovation"]: "Strategy and Innovation",
	["motivations-and-thinking-style"]: "Motivations and Thinking Style",
	["problem-solving"]: "Problem Solving",
	["finance"]: "Finance",
	["team-building-and-teamwork"]: "Team Building and Teamwork",
	["professional-capabilities"]: "Professional Capabilities",
	// ["careers"]: "Careers",
	// ["aapl"]: "AAPL",
};
export const parentTags = {
	"Team Building and Teamwork": {
		color: "#637886",
		childTags: [
			"Team Building",
			"Develop Relationships",
			"Collaborative Function",
			"Working with and Through Others",
		],
	},
	"Professional Capabilities": {
		color: "#65BEBB",
		childTags: ["Integrity", "Judgment", "Accountability", "Influence"],
	},
	"Strategy and Innovation": {
		color: "#64B6CF",
		childTags: ["Performance", "Systems Awareness", "Differentiation", "Environmental Influences"],
	},
	Finance: {
		color: "#B5A58B",
		childTags: ["Financial Management", "Economics", "Resource Allocation", "Payment Models"],
	},
	"Quality and Risk": {
		color: "#EEAA70",
		childTags: ["Quality Improvement", "Healthcare Process", "Risk Management", "Health Law"],
	},
	"Problem Solving": {
		color: "#E48876",
		childTags: ["Strategic Perspective", "Conflict Management", "Action Orientation", "Critical Appraisal Skills"],
	},
	"Self-Management": { color: "#ED70A6", childTags: ["Self-Awareness", "Humility", "Resilience", "Self-Control"] },
	"Motivations and Thinking Style": {
		color: "#BE9FC4",
		childTags: ["Motivate Others", "Adaptability", "Trust and Respect", "Comfort with Visibility"],
	},
	"Operations and Policy": {
		color: "#6193BD",
		childTags: ["Governance", "Communication Strategies", "Technology Integration", "People Management"],
	},
	Careers: { color: "#142541", childTags: ["Career Planning"] },
	AAPL: { color: "#142541", childTags: ["AAPL Board", "AAPL News"] },
};

export const childTags = {
	"AAPL Board": "AAPL",
	"AAPL News": "AAPL",
	"Action Orientation": "Problem Solving",
	"Career Planning": "Careers",
	"Collaborative Function": "Team Building and Teamwork",
	"Comfort with Visibility": "Motivations and Thinking Style",
	"Communication Strategies": "Operations and Policy",
	"Conflict Management": "Problem Solving",
	"Critical Appraisal Skills": "Problem Solving",
	"Develop Relationships": "Team Building and Teamwork",
	"Environmental Influences": "Strategy and Innovation",
	"Financial Management": "Finance",
	"Health Law": "Quality and Risk",
	"Healthcare Process": "Quality and Risk",
	"Motivate Others": "Motivations and Thinking Style",
	"Payment Models": "Finance",
	"People Management": "Operations and Policy",
	"Quality Improvement": "Quality and Risk",
	"Resource Allocation": "Finance",
	"Risk Management": "Quality and Risk",
	"Self-Awareness": "Self-Management",
	"Self-Control": "Self-Management",
	"Strategic Perspective": "Problem Solving",
	"Systems Awareness": "Strategy and Innovation",
	"Team Building": "Team Building and Teamwork",
	"Technology Integration": "Operations and Policy",
	"Trust and Respect": "Motivations and Thinking Style",
	"Working with and Through Others": "Team Building and Teamwork",
	Accountability: "Professional Capabilities",
	Adaptability: "Motivations and Thinking Style",
	Differentiation: "Strategy and Innovation",
	Economics: "Finance",
	Governance: "Operations and Policy",
	Humility: "Self-Management",
	Influence: "Professional Capabilities",
	Integrity: "Professional Capabilities",
	Judgment: "Professional Capabilities",
	Performance: "Strategy and Innovation",
	Resilience: "Self-Management",
};
